/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import "./layout.css";

export const Container = styled.div`
  max-width: 1136px;
  position: relative;
  margin: 0 auto 20px;
  padding: 0 16px;

  @media (max-width: 1136px) {
    padding: 16px;
  }
`;

export const LoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  z-index: 1;
  position: relative;
`;

const Layout = ({ children, className }) => {
  return <Container className={className}>{children}</Container>;
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
